import { OurTreatmentsPage } from "~/components/our-treatments/OurTreatmentsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/our-treatments")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/our-treatments"),
  component: OurTreatmentsPage,
});
